import { Button, Card } from "@aws-amplify/ui-react"

export const BuddyCard = ({ buddy,
    isBuddy,
    onButtonClicked,
    followOpertaionInProgress }) => {
    return (
        <Card className="w-100">
            <div className="d-flex justify-content-between align-items-center w-100"  >
                <div >
                    <div style={{ fontWeight: 'bold' }}>{buddy.name}</div>
                    <div>{buddy.email}</div>
                </div>
                <div >
                    <Button
                        isLoading={followOpertaionInProgress}
                        isDisabled={followOpertaionInProgress}
                        loadingText="In Progress.."
                        onClick={onButtonClicked}>
                        {isBuddy ? <span>Unfollow</span> : <span>Follow</span>}
                    </Button>
                </div>
            </div>

        </Card>
    )
}